module.exports = __webpack_public_path__ + "static/img/quiz-good.2c2df96c.svg";